import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { CheckEmailPageLayoutPropsType } from '../../../../../model/check-email-page';
import { ResendEmailButton } from '../components';
import EnvelopeImg from '../components/EnvelopeImage';
import { messages } from '../messages';
import {
  DevopsButtonGroup,
  Devopsgroup,
  DevopsHeader,
  DevopsImageWrapper,
  DevopsText,
  Wrapper
} from '../styled';

export function LayoutDevops({
  email,
  baseUrl,
  hideHeader,
  checkEmailAnalyticsService
}: CheckEmailPageLayoutPropsType) {
  const DevopsResendPage = (
    <Devopsgroup>
      <DevopsText>
        <FormattedHTMLMessage
          {...messages.devopsEmailSent}
          values={{ email }}
        />
      </DevopsText>
      <DevopsImageWrapper>
        <EnvelopeImg />
      </DevopsImageWrapper>
      <DevopsText className="break">
        <FormattedHTMLMessage {...messages.devopsNoResendNoEmail} />
      </DevopsText>
      <DevopsButtonGroup>
        <ResendEmailButton
          baseUrl={baseUrl}
          checkEmailAnalyticsService={checkEmailAnalyticsService}
        />
      </DevopsButtonGroup>
    </Devopsgroup>
  );

  return (
    <Wrapper>
      <DevopsHeader>
        {!hideHeader && <FormattedMessage {...messages.devopsHeader} />}
        <FormattedMessage {...messages.devopsSubHeader} />
      </DevopsHeader>

      {DevopsResendPage}
    </Wrapper>
  );
}
